import React from 'react';
import classnames from 'classnames';

import './index.scss';

interface IInputBlockProps {
  title?: string;
  hasError?: boolean;
  required?: boolean;
  useSmall?: boolean;
  children: React.ReactNode;
}

const InputBlock: React.FC<IInputBlockProps> = props => {
  const { hasError, title, required, useSmall } = props;
  return (
    <div className={classnames('search_block', { has_error: !!hasError, use_small: !!useSmall })}>
      <div className="search_block_title">{required ? `${title} *` : title}</div>
      {props.children}
      <div className="hidden_arrow" />
    </div>
  );
};

export default InputBlock;
